import {
  ChevronLeft,
  ChevronRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from '@project-lary/react-material-symbols';

import { Button, ButtonVariant } from './button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';

export const pageLimits = [25, 50, 100] as const;
export const DEFAULT_TABLE_PAGE = '1';

export interface DataTablePaginationProps {
  limit: number;
  totalCount: number;
  currentPage: number;
  onSetLimit: (newState: string) => void;
  onSetPage: (newState: string) => void;
}

export function DataTablePagination({
  limit,
  currentPage,
  totalCount,
  onSetPage,
  onSetLimit,
}: DataTablePaginationProps) {
  const pageCount = Math.ceil(totalCount / limit);
  const disablePrevious = currentPage === 1;
  const disableNext = currentPage >= pageCount;

  const handleChangeLimit = (value: string) => {
    onSetLimit(value);
    onSetPage(DEFAULT_TABLE_PAGE);
  };

  return (
    <div className="flex items-center justify-end border-neutral-alpha-6 border-t p-2">
      <div className="flex items-center space-x-6 lg:space-x-8">
        <div className="flex items-center space-x-2">
          <p className="font-medium text-sm">Zeilen pro Seite</p>
          <Select value={`${limit}`} onValueChange={handleChangeLimit}>
            <SelectTrigger className="h-8 w-[70px]">
              <SelectValue placeholder={limit} />
            </SelectTrigger>
            <SelectContent side="top">
              {pageLimits.map((pageSize) => (
                <SelectItem key={pageSize} value={`${pageSize}`}>
                  {pageSize}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex w-[100px] items-center justify-center font-medium text-sm">
          Seite {pageCount === 0 ? pageCount : currentPage} von {pageCount}
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant={ButtonVariant.surface_neutral}
            className="hidden size-8 p-0 lg:flex"
            onClick={() => onSetPage(DEFAULT_TABLE_PAGE)}
            disabled={disablePrevious}
          >
            <span className="sr-only">Gehen Sie zur ersten Seite</span>
            <KeyboardDoubleArrowLeft />
          </Button>
          <Button
            variant={ButtonVariant.surface_neutral}
            className="size-8 p-0"
            onClick={() => onSetPage(String(currentPage - 1))}
            disabled={disablePrevious}
          >
            <span className="sr-only">Zurück zur letzten Seite</span>
            <ChevronLeft />
          </Button>
          <Button
            variant={ButtonVariant.surface_neutral}
            className="size-8 p-0"
            onClick={() => onSetPage(String(currentPage + 1))}
            disabled={disableNext}
          >
            <span className="sr-only">Gehen Sie zur nächsten Seite</span>
            <ChevronRight />
          </Button>
          <Button
            variant={ButtonVariant.surface_neutral}
            className="hidden size-8 p-0 lg:flex"
            onClick={() => onSetPage(String(pageCount))}
            disabled={disableNext}
          >
            <span className="sr-only">Gehe zur letzten Seite</span>
            <KeyboardDoubleArrowRight />
          </Button>
        </div>
      </div>
    </div>
  );
}
